import { useAuthState } from './AuthProvider'

/**
 * Last-known access token — synchronous. Returns `null` when there is no
 * live session. Note this does NOT trigger a refresh; for that use
 * `useAuth().getAccessToken()`.
 */
export const useAccessToken = (): string | null => {
    const state = useAuthState()
    if (state.tag === 'authenticated' || state.tag === 'refreshing') {
        return state.session.accessToken
    }
    return null
}
